module.exports = __webpack_public_path__ + "assets/images/seatingarrangement-03.3aa9507bb3602fbf9bb5216dd5608de1.svg";